import { Component, inject } from '@angular/core';
import { TopWidgetComponent } from './top-widget/top-widget.component';
import { ActiveMissionsComponent } from './active-missions/active-missions.component';
import { AuthService, BalanceService } from 'core';
import { FeaturedPromotionsComponent } from './featured-promotions/featured-promotions.component';
import { FeaturedRewardsComponent } from './featured-rewards/featured-rewards.component';
import { CommunitysMetricsComponent } from './communitys-metrics/communitys-metrics.component';
import { CommunityGrowthComponent } from './community-growth/community-growth.component';
import { MetricsCardComponent } from '../../dashboard-v2/metrics-card/metrics-card.component';

@Component({
  selector: 'app-dashboard-v2',
  host: { '[class.member-dashboard]': '!currentUserIsSpecial' },
  imports: [
    TopWidgetComponent,
    ActiveMissionsComponent,
    FeaturedPromotionsComponent,
    FeaturedRewardsComponent,
    CommunitysMetricsComponent,
    CommunityGrowthComponent,
    MetricsCardComponent
  ],
  templateUrl: './dashboard-v2.component.html',
  styleUrl: './dashboard-v2.component.scss'
})
export class DashboardV2Component {
  authService = inject(AuthService);
  balanceService = inject(BalanceService);

  currentUser = this.authService.currentUser$;

  get currentUserIsSpecial() {
    return this.currentUser()?.isSpecial ?? false;
  }

  get lessThan500Ganas() {
    return this.balanceService.spendableGanas() < 500;
  }
}
